/* eslint-disable @microsoft/sdl/react-iframe-missing-sandbox */
import { CustomImage } from '@app/components/various/CustomImage';
import { getDefaultImageAspectRatio } from '@app/ducks/helpers';
import { getIsImageMedia, getIsVideoMedia } from '@app/services/media';
import { cn } from '@app/utils/cn';
import { handleSpaceAndEnter } from '@app/utils/handleEnterKey';
import { AnyMedia } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  media: AnyMedia | undefined;
  autoPlayVideo?: boolean;
  className?: string;
  onClick?: VoidFunction;
}

export const ProductDetailsMedia = ({ media, className, autoPlayVideo = false, onClick }: Props) => {
  const { t } = useTranslation(['products']);
  const aspectRatio = useSelector(getDefaultImageAspectRatio);

  return (
    <div
      role="button"
      tabIndex={0}
      className={cn('flex h-full items-center', className)}
      onClick={onClick}
      onKeyDown={handleSpaceAndEnter(onClick)}
    >
      {getIsImageMedia(media) && <CustomImage src={media.src} imageClassName="cursor-zoom-in" aspectRatio={aspectRatio} />}
      {getIsVideoMedia(media) && (
        <div className="aspect-video w-full">
          <iframe
            title={t('products:product_video')}
            src={`https://player.vimeo.com/video/${media.src}?autoplay=${autoPlayVideo}&title=0&byline=0&portrait=0`}
            className="h-full w-full"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin allow-presentation"
          />
        </div>
      )}
    </div>
  );
};
